import type { ThemeUIStyleObject } from '@jotta/ui/themeui'

export type BaseThemeSection = {
  [K: string]: ThemeUIStyleObject
}
export function makeVariant<T extends BaseThemeSection>(styles: T): T {
  return styles
}
